export const NAME = 'SingleFlightTracker';
